import React, { Component, Fragment } from "react";
import { inject, observer } from 'mobx-react';
import grapesjs from "grapesjs";
import 'grapesjs/dist/css/grapes.min.css';
import 'grapesjs-preset-webpage';
import 'grapesjs-preset-newsletter';
// import 'grapesjs-preset-newsletter/dist/grapesjs-preset-newsletter.css';
import "../../../assets/scss/pages/settings.scss";
import { toast } from "react-toastify";
import nl from "./defaultTemplate/newsLetter.js";
import wp from "./defaultTemplate/webPage.js";
import {Spinner} from "reactstrap"


@inject('templateStore')
@observer
class TemplateBuilder extends Component {
  constructor(props) {
    super(props);
    this.editor = null;
    this.state = {
      editMode : true,
      loading: true
    }
  }

  async componentDidMount() {
    const { match } = this.props;
    let { templateStore } = this.props;
    await templateStore.loadTemplate(match.params.templateId);
    if (match.params.mode == 'view'){
      this.setState({editMode: false})
    }
    this.loadEditor();
  }

  loadEditor = () => {
    const { templateStore } = this.props;
    const { template } =  templateStore;
    
    if (template.type === 'page') {
      this.pageEditor(template)
    }

    if (template.type === 'email' || template.type === 'meeting') {
      this.emailEditor(template)
    }
  }

  pageEditor = async (template) => {
    let content = template.content == "" ? wp : template.content;
    this.setState({ loading: false});
    this.editor = grapesjs.init({
      container: '#gjs',
      components: content,
      width: '100vw',
      height: '100vh',
      storageManager: {
        id: 'sp-',
        type: 'local',          
        autosave: true,         
        autoload: false,      
      },
      plugins: ['gjs-preset-webpage'],
      pluginsOpts: {
        'gjs-preset-webpage': {
          filestackOpts: false
        }
      },
      commands: {
        defaults: [
          {
            id: 'save-editor-dialog',
            run() {
              console.log('Saving Data');
            },
          }, {
            id: 'close-editor-dialog',
            run() {
              console.log('Closing Editor');
            },
          }
        ],
      }
    });
    // adding save button
    this.editor.Panels.addButton('options',{
      id: 'save-content',
      className: 'fa fa-floppy-o',
      command: 'save-editor-dialog',
      attributes: { title: 'Save & Exit'},
      active: false,
    });

    // adding close button
    this.editor.Panels.addButton('options',{
      id: 'exit-editor',
      className: 'fa fa-times',
      command: 'close-editor-dialog',
      attributes: { title: 'Exit without Saving'},
      active: false,
    });

    this.editor.Panels.removeButton('options', 'export-template');
    this.editor.runCommand('sw-visibility');
    if (this.state.editMode == false) {
      this.editor.runCommand('preview')
    }
    // event listners
    this.editor.on('run:save-editor-dialog', commandId => {
      this.saveEditor(template);
    })
    this.editor.on('run:close-editor-dialog', commandId => {
      this.closeEditor();
    })
    // try{ 
    //   this.editor.runCommand('fullscreen', {  target: '#gjs' });
    // }
    // catch(e) {
    //   console.log(e);
    // }
  }

  emailEditor = async (template) => { 
    let content = template.content == "" ? nl : template.content;
    this.setState({ loading: false});
    this.editor = grapesjs.init({
      container: '#gjs',
      components: content,
      width: '100vw',
      height: '100vh',
      storageManager: {
        id: 'sp-',
        type: 'local',          
        autosave: true,         
        autoload: false,      
      },
      plugins: ['gjs-preset-newsletter'],
      pluginsOpts: {
        'gjs-preset-newsletter': { }
      },
      commands: {
        defaults: [
          {
            id: 'save-editor-dialog',
            run() {
              console.log('Saving Data');
            },
          }, {
            id: 'close-editor-dialog',
            run() {
              console.log('Closing Editor');
            },
          }
        ],
      }
    });

    // adding save button
    this.editor.Panels.addButton('options',{
      id: 'save-content',
      className: 'fa fa-floppy-o',
      command: 'save-editor-dialog',
      attributes: { title: 'Save & Exit'},
      active: false,
    });

    // adding save button
    this.editor.Panels.addButton('options',{
      id: 'exit-editor',
      className: 'fa fa-times',
      command: 'close-editor-dialog',
      attributes: { title: 'Exit without Saving'},
      active: false,
    });

    this.editor.Panels.removeButton('options', 'export-template');
    this.editor.runCommand('sw-visibility');

    if (this.state.editMode == false) {
      this.editor.runCommand('preview')
    }

    // event listners
    this.editor.on('run:save-editor-dialog', commandId => {
      this.saveEditor(template);
    })
    this.editor.on('run:close-editor-dialog', commandId => {
      this.closeEditor();
    })
    // try{ 
    //   this.editor.runCommand('fullscreen', {  target: '#gjs' });
    // }
    // catch(e) {
    //   console.log(e);
    //   debugger
    // }
  }

  closeEditor = async () => {   
    alert('Changes are not Saved!!')
    this.editor.destroy();
    window.close()
  }

  saveEditor = async (template) => {
    toast.info('Template Saved!')
    // getting data from editor
    const htmlBody = this.editor.getHtml();
    const cssStyle = this.editor.getCss();
    const jsScript = this.editor.getJs();

    const { templateStore } = this.props;
    await templateStore.templateBuilder(htmlBody, cssStyle, jsScript, template);
    
    this.editor.destroy();
    window.close();
  }

  render() {
    const loadingProgress = (
      <div className="loader-position">
        <Spinner type="grow" color="primary" />
        <Spinner type="grow" color="success" />
        <Spinner type="grow" color="info" />
        <Spinner type="grow" color="danger" />
        <Spinner type="grow" color="warning" />
        <Spinner type="grow" color="light" />
        <Spinner type="grow" color="dark" />
      </div>
    )

    return (
      <React.Fragment>
        {this.state.loading == true ? loadingProgress : <div></div>}
        <div className="editor-container">
          <div id="gjs"></div>
        </div>
      </React.Fragment>
      
    )
  }
}

export default TemplateBuilder;